import React, {Component} from 'react';
import $ from 'jquery';
import {Link, browserHistory } from 'react-router';
// import StarRating from 'react-bootstrap-star-rating';
import {Tab,Tabs,ButtonToolbar,DropdownButton,MenuItem,Modal} from 'react-bootstrap';
import ReactStars from 'react-stars';
import { ccAvenue,razorpayForm } from "../../functions/custom_functions.js";
import {connect} from 'react-redux';
import * as actions from '../../../actions';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets//';

class My_Orders extends Component{
	constructor(props){
		super(props);
		this.state={
			cart_count:0,
			activeTab:1,
			bookings:[],
			cancel_bookings:[],
			bookings_count:'',
			cancel_count:0,
			orders_list_status:false,
			book_type:'',
			// payment variables starts here
			pre_payment_id:'',
			order_id:'',
			paid_amt:'',
			username:'',
			address:'',
			city:'',
			state:'',
			pincode:'',
			mobile:'',
			email:'',
			cancel_modal_status:false,
			cancel_reasons:[],
			edit_input_status:false,
			edit_input:'',
			bid:'',
			booking_type:'',
			selected_reason:'',
			cancel_success_status:false,
			cancel_success_msg:'',
			test_orders:[],
			gateway_mode: '',
			pageId:'.mob_myorders_page',	
		}
		this.getCartCount=this.getCartCount.bind(this);
		this.handleTabsSelect=this.handleTabsSelect.bind(this);
		this.getOrdersList=this.getOrdersList.bind(this);
		this.repeatOrder=this.repeatOrder.bind(this);
		this.getBookingsFilterbyType=this.getBookingsFilterbyType.bind(this);
		this.getBookingsFilterbyStatus=this.getBookingsFilterbyStatus.bind(this);
		this.payNow=this.payNow.bind(this);
		this.ccAvenue=this.ccAvenue.bind(this);
		this.getCancelDetails=this.getCancelDetails.bind(this);
		this.handleCancel_Submit=this.handleCancel_Submit.bind(this);
		this.openCancelModal=this.openCancelModal.bind(this);
		this.close=this.close.bind(this);
		this.selectedReason=this.selectedReason.bind(this);
		this.update_other_reason=this.update_other_reason.bind(this);

		this.ratingChanged=this.ratingChanged.bind(this);
		this.openRatingsPage=this.openRatingsPage.bind(this);

		this.getCancelBookingsFilter=this.getCancelBookingsFilter.bind(this);
	}

	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href="/web/myorders";
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('myorders','/myorders');
			browserHistory.push('/login');
		}
		if(localStorage.user_id && localStorage.token)
		{
			this.getCartCount();
			this.getOrdersList();
		}
		localStorage.removeItem('book_date');
		localStorage.removeItem('seller');
		localStorage.removeItem('vid');
		localStorage.removeItem('order_details');
	}
	close()
	{
		this.setState({
			cancel_modal_status:false,
			cancel_success_status:false,
		});
	}
	
	openRatingsPage(bid,booking_type,give_rate,seller,book_date,vid,product_id)
	{
		// Seed -> booking_type = 0;
		// Product -> booking_type = 1;
		localStorage.setItem('book_date',book_date);
		localStorage.setItem('seller',seller);
		localStorage.setItem('vid',vid);
		localStorage.setItem('product_id',product_id);
		
		if(booking_type ===1 && give_rate ==='no')
		{
			browserHistory.push('/viewrating/product/'+bid);	
		}
		else if(booking_type===0 && give_rate ==='no')
		{
			browserHistory.push('/viewrating/'+bid);
		}
		else if(booking_type ===1 && give_rate ==='yes')
		{
			browserHistory.push('/giverating/product/'+bid);	
		}
		else if(booking_type===0 && give_rate ==='yes')
		{
			browserHistory.push('/giverating/'+bid);
		}
	}
	getBookingsFilterbyStatus(status)
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',uid:localStorage.user_id,token:localStorage.token,status:status,type:''}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getBookings',
			success:function(data)
			{
				this.setState({
					bookings:data.bookings,
					cancel_bookings:data.cancel_bookings,
					bookings_count:data.bookings_count,
					cancel_count:data.cancel_count,
				});
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	getBookingsFilterbyType(type)
	{
	    var type = type.toString();
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',uid:localStorage.user_id,token:localStorage.token,status:'',type:type}
		var data2=JSON.stringify(data1);
		$.ajax({
	   		method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getBookings',
			success:function(data)
			{
				this.setState({
					bookings:data.bookings,
					cancel_bookings:data.cancel_bookings,
					bookings_count:data.bookings_count,
					cancel_count:data.cancel_count,
				});
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	getCancelBookingsFilter(type)
	{   var type = type.toString();
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',uid:localStorage.user_id,token:localStorage.token,status:'',type:type}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getBookings',
			success:function(data)
			{
				this.setState({
					bookings:data.bookings,
					cancel_bookings:data.cancel_bookings,
					bookings_count:data.bookings_count,
					cancel_count:data.cancel_count,
				});
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	repeatOrder(booking_id)
	{
		if(localStorage.source)
	    {
	        var source=localStorage.getItem('source');
	    }
	    else
		{
		    source='';
		  }
		  if(localStorage.campaign)
		  {
		    var campaign=localStorage.getItem('campaign');
		  }
		  else
		  {
		    campaign='';
		  }
		  if(localStorage.url_id)
		  {
		    var url_id=localStorage.getItem('url_id');
		  }
		  else
		  {
		    url_id='';
		  }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,booking_id:booking_id,source:source,campaign:campaign,url_id:url_id};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'recap_cart',
			success:function(data)
			{
				if(data.status==="success")
				{
					browserHistory.push('/mycart');
					// this.getOrdersList();
				}
			},
			error:function(err)
			{

			}
		});
	}
	update_other_reason(event)
	{
		this.setState({
			edit_input:event.target.value,
		});
	}
	getCartCount()
	{
		    var baseUrl='https://aquadeals.in/admin/web3/user/';
		    var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		          method: 'POST',
		          url: baseUrl+'cart_count',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
		            this.setState({
		                cart_count:data.cart_count,
		            });
		          }.bind(this),
		          error: function(err){
		          
		          }
		    });
	}
	handleTabsSelect(key)
	{
		this.setState({
			activeTab:key,
		});
	}
	componentWillMount()
	{
		var that=this;
		setTimeout(function(){
			that.enableOrdersList();
		},3000);
	}
	enableOrdersList()
	{
		// this.getCart();
		this.setState({
			orders_list_status: true,
		});
	}
	getOrdersList()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',uid:localStorage.user_id,token:localStorage.token,status:'',type:''}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getBookings',
			success:function(data)
			{
				this.setState({
					bookings:data.bookings,
					cancel_bookings:data.cancel_bookings,
					bookings_count:data.bookings_count,
					cancel_count:data.cancel_count,
					gateway_mode:data.gateway_mode
				});
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	ccAvenue()
	{
		var basePayUrl='https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
		// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';

		var username=this.state.username;
		var address=this.state.address;
		var city=this.state.city;
		var state=this.state.state;
		var pincode=this.state.pincode;
		var mobile=this.state.mobile;
		var email=this.state.email;
		var rem_amt = 'rem_amt';
		var deal_type = this.state.book_type;
		
		var data1={access_code:'AVIJ67DJ41BD20JIDB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',redirect_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
		// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};

		$.ajax({
			method:'POST',
			data:data1,
			url:basePayUrl,
			success:function(data)
			{
				$('.mob_myorders_page').html(data);
			},
			error:function(err)
			{
			}
		});
	}
	payNow(book_id,paid_amt,pay_type,book_type,u_name,u_address,u_phone,u_zip,u_city,u_state,u_email)
	{
		if(localStorage.source)
	      {
	        var source=localStorage.getItem('source');
	      }
	      else
	      {
	        source='';
	      }
	      if(localStorage.campaign)
	      {
	        var campaign=localStorage.getItem('campaign');
	      }
	      else
	      {
	        campaign='';
	      }
	      if(localStorage.url_id)
	      {
	        var url_id=localStorage.getItem('url_id');
	      }
	      else
	      {
	        url_id='';
	      }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,book_id:book_id,paid_amt:paid_amt,pay_type:pay_type,book_type:book_type,source:source,campaign:campaign,url_id:url_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			url: baseUrl+'rem_amt_temp_process',
			dataType:'json',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						pre_payment_id:data.pre_payment_id,
						order_id:data.order_id,
						paid_amt:data.paid_amt,
						book_type:book_type,

						username:u_name,
						address:u_address,
						city:u_city,
						state:u_state,
						pincode:u_zip,
						mobile:u_phone,
						email:u_email,
					});
				}
				var payment_params= {from:'desktop_web',
				uid:localStorage.getItem('user_id'),
				pre_payment_id:data.pre_payment_id,
				order_id:data.order_id,
				deal_type:this.state.book_type,
				cart_ids:'',
				paid_amt:data.paid_amt,
				username: this.state.username,
				address:this.state.address,
				city:this.state.city,
				state:this.state.state,
				pincode:this.state.pincode,
				mobile:this.state.mobile,
				country:'India',
				email:this.state.email,
				cart_add_id:'rem_amt',
				pageId:this.state.pageId,
				rzp_key:this.props.rzp_keys.key_id};				
			if(this.state.gateway_mode == 2){										
				razorpayForm(payment_params);					
			}else{
				ccAvenue(payment_params);					
			}

				//this.ccAvenue();
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}

		});
	}
	getCancelDetails()
	{
		var baseUrl ='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token}
		var data2=JSON.stringify(data1);

		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'cancel_reasons',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						cancel_reasons:data.reasons,
					});
				}
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}
		});
	}
	handleCancel_Submit(event)
	{
		event.preventDefault();
		var	bid= this.state.bid;
		var booking_type = this.state.booking_type;
		var selected_reason = this.state.selected_reason;
		if(this.state.selected_reason===9)
		{
			selected_reason=this.state.edit_input;
		}
		if(localStorage.source)
	      {
	        var source=localStorage.getItem('source');
	      }
	      else
	      {
	        source='';
	      }
	      if(localStorage.campaign)
	      {
	        var campaign=localStorage.getItem('campaign');
	      }
	      else
	      {
	        campaign='';
	      }
	      if(localStorage.url_id)
	      {
	        var url_id=localStorage.getItem('url_id');
	      }
	      else
	      {
	        url_id='';
	      }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		if(booking_type ===1)
		{
			var action_url = 'product_booking_cancel';
			var data1={from:'mobile_web',uid:localStorage.user_id,token:localStorage.token,reason:selected_reason,book_id:bid,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
		}
		else
		{
			action_url = 'booking_cancel';
			data1={from:'mobile_web',uid:localStorage.user_id,token:localStorage.token,book_id:bid,reason:selected_reason,source:source,campaign:campaign,url_id:url_id}
			data2=JSON.stringify(data1);	
		}

		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+action_url,
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						cancel_modal_status:false,
						cancel_success_status:true,
						cancel_success_msg:data.message,
					});
					// alert(data.message);
					// window.location.reload();
					this.getOrdersList();
				}
				else
				{
					this.setState({
						cancel_modal_status:false,
						cancel_success_status:true,
						cancel_success_msg:data.message,
					});
					this.getOrdersList();
					// alert(data.message);
					// window.location.reload();
				}
			}.bind(this),
			error:function(err)
			{

			}
		})
	}
	openCancelModal(bid,booking_type)
	{
		this.setState({
			cancel_modal_status:true,
			bid:bid,
			booking_type:booking_type,
		});
	}
	selectedReason(id,flag)
	{
		if(flag==='1')
		{
			this.setState({
				edit_input_status:true,
				selected_reason:id,
			});
		}
		else
		{
			this.setState({
				edit_input_status:false,
				selected_reason:id,
			})
		}
	}
	ratingChanged(newRating)
	{
  		console.log(newRating)
	}
	render(){
		document.title="My Orders | AquaDeals";
		// $(window).scrollTop(0);
		$('body').css('background','#f1f1f2');
		var orders_tabs='';
		if(this.state.bookings_count===0)
		{
			var bookings = <div className="no_ordrs_blk" style={{marginTop:'150px',textAlign:'center'}}><p>No orders were made</p><Link to={'/'}>EXPLORE BEST DEALS</Link></div>;
		}
		else
		{
			bookings=this.state.bookings.map(function(order,index){
			var status='';
			var rating='';
			var repeat='';
			// paynow and cacel blk start here
			var paynow_cancel='';
			if(order.rem_amt_flag==='1' || order.rem_amt_flag==='2')
			{
				paynow_cancel='';
			}
			else if(order.rem_amt_flag==='0' && order.cancel_flag===1)
			{
				var pay_type =1;
				
				var u_name = order.shipping_details ? order.shipping_details.name : '';
				var u_address= order.shipping_details ? order.shipping_details.address : '';
				var u_phone = order.shipping_details ? order.shipping_details.phone	:'';
				var u_zip = order.shipping_details ? order.shipping_details.zip : '';
				var u_city = order.shipping_details ? order.shipping_details.city : '';
				var u_state = order.shipping_details ? order.shipping_details.state : '';
				//var u_default_flag = order.shipping_details ? order.shipping_details.default_flag : '';
				//var u_behalf_of = order.shipping_details ? order.shipping_details.behalf_of : '';
				//var u_status = order.shipping_details ? order.shipping_details.status : '';
				var u_email = order.shipping_details ? order.shipping_details.email : '';

				paynow_cancel=<div className="pay_cancel_blk"><p><span onClick={()=>{this.payNow(order.booking_id,order.order_amount,pay_type,order.booking_type,u_name,u_address,u_phone,u_zip,u_city,u_state,u_email)}}>PAY NOW </span><span style={{float:'right',cursor:'pointer'}} onClick={()=>{this.openCancelModal(order.bid,order.booking_type)}}>CANCEL</span></p></div>
			}
			else if(order.rem_amt_flag==='0' && order.cancel_flag===0)
			{
				pay_type = 1;
				u_name = order.shipping_details ? order.shipping_details.name : '';
				u_address= order.shipping_details ? order.shipping_details.address : '';
				u_phone = order.shipping_details ? order.shipping_details.phone	:'';
				u_zip = order.shipping_details ? order.shipping_details.zip : '';
				u_city = order.shipping_details ? order.shipping_details.city : '';
				u_state = order.shipping_details ? order.shipping_details.state : '';
				//u_default_flag = order.shipping_details ? order.shipping_details.default_flag : '';
				//u_behalf_of = order.shipping_details ? order.shipping_details.behalf_of : '';
				//u_status = order.shipping_details ? order.shipping_details.status : '';
				u_email = order.shipping_details ? order.shipping_details.email : '';
				paynow_cancel=<div className="pay_blk" style={{marginTop:'10px',paddingTop:'5px',borderTop:'1px solid #f1f1f2'}}><p onClick={()=>{this.payNow(order.booking_id,order.order_amount,order.status,order.booking_type,u_name,u_address,u_phone,u_zip,u_city,u_state,u_email)}}><span>PAY NOW</span></p></div>;
			}
			// paynow and cacel blk ENDS here
			// cancel blk starts here
			var cancel ='';
			if(order.rem_amt_flag === '1' && order.cancel_flag === 1)
			{
				cancel = <div className="cancel_blk" onClick={()=>{this.openCancelModal(order.bid,order.booking_type)}} style={{textAlign:'center',color:'#ff742a',cursor:'pointer'}}><p><span>CANCEL</span></p></div>;
			}
			// cancel blk ends here
			// rating status with rating and repeat status
			if(order.status==='2' && order.rate===1)
			{
				var give_rate = 'no';
				rating=<div className="order_rate_blk">
							<p>View Rating</p>
							<div className="rate_blk" onClick={()=>{this.openRatingsPage(order.bid,order.booking_type,give_rate,order.seller,order.book_date,order.vid,order.product_id)}}>
								<ReactStars
								  count={5}
								  onChange={this.ratingChanged}
								  className={'rate_blk_item'}
								  size={50}
								  value={order.rating}
								  edit={false}
								  color1={'#F3F3F3'}
								  color2={'#FABB9A'} />
							</div>
						</div>;
			}
			else
			{
				rating='';
			}
			if(order.status==='6' && order.rate===1)
			{
				give_rate = 'yes';
				rating=<div className="order_rate_blk">
							<p className="rate_desc">Rate the order based on your experience</p>
							<div className="rate_blk" onClick={()=>{this.openRatingsPage(order.bid,order.booking_type,give_rate,order.seller,order.book_date,order.vid,order.product_id)}}>
								<ReactStars
								  count={5}
								  onChange={this.ratingChanged}
								  className={'rate_blk_item'}
								  size={50}
								  value={order.rating}
								  edit={false}
								  color1={'#F3F3F3'}
								  color2={'#FABB9A'} />
							</div>
						</div>;
				repeat=<div style={{textAlign:'center',color:'#ff742a',cursor:'pointer',marginTop:'10px'}} onClick={()=>{this.repeatOrder(order.booking_id)}}>REPEAT</div>;
			}

			if(order.status==='2' && order.rate===2)
			{
				repeat=<div style={{textAlign:'center',color:'#ff742a',cursor:'pointer',marginTop:'10px'}} onClick={()=>{this.repeatOrder(order.booking_id)}}>REPEAT</div>;
			    give_rate = 'no';
				rating=<div className="order_rate_blk">
							<p>View Rating</p>
							<div className="rate_blk" onClick={()=>{this.openRatingsPage(order.bid,order.booking_type,give_rate,order.seller,order.book_date,order.vid,order.product_id)}}>
								<ReactStars
								  count={5}
								  onChange={this.ratingChanged}
								  className={'rate_blk_item'}
								  size={50}
								  edit={false}
								  color1={'#F3F3F3'}
								  value={order.rating}
								  color2={'#FABB9A'} />
							</div>
						</div>;
				// set rating
			}
			if(order.status==='6' && order.rate===2)
			{
				give_rate = 'no';
				rating=<div className="order_rate_blk" >
							<p>View Rating</p>
							<div className="rate_blk" onClick={()=>{this.openRatingsPage(order.bid,order.booking_type,give_rate,order.seller,order.book_date,order.vid,order.product_id)}}>
								<ReactStars
								  className={'rate_blk_item'}
								  count={5}
								  onChange={this.ratingChanged}
								  size={50}
								  edit={false}
								  color1={'#F3F3F3'}
								  value={order.rating}
								  color2={'#FABB9A'} />
							  </div>
						</div>;
				//set Rating;
				repeat=<div style={{textAlign:'center',color:'#ff742a',cursor:'pointer',marginTop:'10px'}} onClick={()=>{this.repeatOrder(order.booking_id)}}>REPEAT</div>;
			}	

			// order status like placed,shipping,delivered starts here
			if(order.status==='0' || order.status==='4' || order.status==='7')
			{
				status='Placed';
			}
			else if(order.status==='1')
			{
				status='Processing';
			}
			else if(order.status==='3')
			{
				status='Cancelled';
			}
			else if(order.status==='5')
			{
				status='Shipping';
			}
			else if(order.status==='6')
			{
				status='Delivered';
			}
			// order status like placed,shipping,delivered ends here
			return(
				<div className="order_item">
					<Link to={'/order_details/'+order.booking_type+'/'+order.bid} className="my_order_link" >
				{/*<Link to={order.booking_type ===0 ? '/order_details/'+order.booking_type+'/'+order.booking_id  : '/order_details/'+order.booking_type+'/'+order.bid} className="my_order_link" >*/}
						<p><span>Order No {order.booking_id}</span><span className="ordr_right">&#8377;{order.order_amount_online}</span></p>
						<p className="order_status"><span style={{color:'#666'}}>{order.book_date}</span><span className="ordr_right ordr_status">{status}</span></p>
						<div className="order_list_items">
							{order.items.length > 0 ? order.items.map(function(item,index){
								return(
									<div className="col-xs-12 col-md-12 order_subitems">
										<div className="col-xs-3 col-md-3" style={{padding:'0px'}}>
											<i className="order_icon"><img src={'https://aquadeals.in/admin/assets/images/'+item.image} alt="" /></i>
										</div>
										<div className="col-xs-9 col-md-9" style={{padding:'0px'}} >
											<p>{item.title}</p>
											<p className="order_qty">Quantity {item.quantity}</p>
										</div>
									</div>
								);	
							}) : ''}
						</div>
						<div className="col-md-12">
							<i><img src={'https://aquadeals.in/admin/assets/images/product_imgs/'+order.progress_bar} alt="" /></i>
						</div>
					</Link>
					<div className="order_rating_blk">
							{rating}
					</div>
					<div className="order_actions_blk">
						<div className="col-md-12 col-sm-12 col-xs-12">
							{paynow_cancel}
							{cancel}
							{repeat}
						</div>
					</div>
				</div>
			);
		}.bind(this))
}
		if(this.state.cancel_count===0)
		{
			var cancel_bookings=<div className="no_ordrs_blk" style={{marginTop:'150px',textAlign:'center'}}><p>No Orders were made</p><Link to={'/'}>EXPLORE BEST DEALS</Link></div>;
		}
		else
		{
		cancel_bookings=this.state.cancel_bookings.map(function(order,index){
			var status='';
			if(order.status==='3')
			{
				status='Cancelled';
			}
			return(
				<div className="order_item">
					<Link to={'/order_details/'+order.booking_type+'/'+order.bid} className="my_order_link" >
						<p><span>Order No {order.booking_id}</span><span className="ordr_right">&#8377;{order.order_amount}</span></p>
						<p className="order_status"><span style={{color:'#666'}}>{order.book_date}</span><span className="ordr_right" style={{color:'red'}}>{status}</span></p>
						<div className="order_list_items">
							{order.items.length > 0 ? order.items.map(function(item,index){
								return(
									<div className="col-xs-12 col-md-12 order_subitems">
										<div className="col-xs-3 col-md-3" style={{padding:'0px'}}>
											<i className="order_icon"><img src={'https://aquadeals.in/admin/assets/images/'+item.image} alt="" /></i>
										</div>
										<div className="col-xs-9 col-md-9" style={{padding:'0px'}} >
											<p>{item.title}</p>
											<p className="order_qty">Quantity {item.quantity}</p>
										</div>
									</div>
								);	
							}) : ''}
						</div>
					</Link>
				</div>
		);
		});
	}

		orders_tabs=<Tabs activeKey={this.state.activeTab} tabWidth={2} className="my_ordr_tabs" id="my_orders_tabs" onSelect={this.handleTabsSelect} >
					<Tab eventKey={1} tabClassName="mob_orders_tab" title={"MY ORDERS : "+this.state.bookings_count}>
						<div>{bookings}</div>
					</Tab>
					<Tab eventKey={2} tabClassName="mob_orders_tab" title={"CANCELLED : "+this.state.cancel_count}>
						<div>{cancel_bookings}</div>
					</Tab>
					</Tabs>;
		
		var cancel_reasons = this.state.cancel_reasons.map(function(data,index){
			return(
				<div>
					<input type="radio" id={data.id} name={'reason'} className="cancel_radio" onClick={()=>{this.selectedReason(data.id,data.flag)}} />
					<span>{data.reason}</span>
					{data.flag==='1' ? <div className="other_reason_blk">{this.state.edit_input_status ? <input type="text" name="other_reason" ref="other_reason" id="other_reason" placeholder="Enter any reason" value={this.state.edit_input} onChange={this.update_other_reason} /> :''}</div> : ''}
				</div>
			);
		}.bind(this));
		return(
			<div className="mob_deals mob_myorders_page">
				<div className="page_hdr">
					<div className="container-fluid">
						{/*<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link>My Orders</h5>*/}
						<h5><Link to={'/'}><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link>My Orders</h5>
						<a href="/" title="Home" className="home_logo1"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home1.png'} alt="Home" /></a>
				       	<a className="mob_cart_btn" href="/mycart">
							<img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png'} />
							{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
						</a>
					</div>
				</div>
				<div className="pag_cntnt3">&nbsp;</div>
				<section className="orders_content">
					{orders_tabs}
				</section>
				<Modal onEntered={()=>{this.getCancelDetails()}}  className="" show={this.state.cancel_modal_status} onHide={this.close} >
						<Modal.Header className="modal_offer_header" closeButton>
				    		<Modal.Title className="m_title" style={{textAlign:'center',color:'#fff'}}>Order Cancellation</Modal.Title>
				  		</Modal.Header>
				  		<Modal.Body>
				  			<div>
				  				<p>Do you want to cancel this Order?</p>
				  				{/*{this.state.processing ? <i><img src={""} /></i>} */}
				  				<form className="cancel_reasons_form" onSubmit={this.handleCancel_Submit}>
				  					<div className="">
					  					{cancel_reasons}
				  					</div>
				  					<div>
				  						<div className="modal-footer">
						  					<a className="cancel_no_btn" onClick={this.close}>No</a>
						  					<button type="submit" className="cancel_yes_btn">Yes</button>
						  				</div>
						  			</div>
				  				</form>
				  			</div>
				  		</Modal.Body>
				  	</Modal>
				{this.state.activeTab===1 ? 
				<section className="seed_sort dsl_srt">
			        <ul>
			            <li className="col-md-6 col-xs-6 col-sm-6 ">
			                <ButtonToolbar>
			                    <DropdownButton className="order_filter_1" noCaret title='By Order Status' dropup >
			                        <MenuItem header>By Order Status</MenuItem>
			                        <MenuItem className="seed_list1"  onClick={()=>this.getBookingsFilterbyStatus('')} >All</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={0} onClick={()=>this.getBookingsFilterbyStatus(0)}>Placed</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={5} onClick={()=>this.getBookingsFilterbyStatus(5)}>Shipping</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={6} onClick={()=>this.getBookingsFilterbyStatus(6)}>Delivered</MenuItem>
			                    </DropdownButton>
			                </ButtonToolbar>
			                {/*<ButtonToolbar>
			                    <DropdownButton className="test_filter_1" noCaret onClick={this.getSorts} title={this.state.sort_title} dropup>
			                        <MenuItem header>By Order Status</MenuItem>{this.state.sort_list.map((cat,index) => (<MenuItem className="seed_list1" eventKey={cat.id} onClick={()=>this.getSelectedBrandSort(cat.id,cat.name)} >{cat.name}</MenuItem>))}
			                    </DropdownButton>
			                </ButtonToolbar>*/}
			            </li>
			            <li className="col-md-6 col-xs-6 col-sm-6 coast_list1">
			                <ButtonToolbar>
			                    <DropdownButton className="order_filter_2" noCaret onClick={this.getBrands} title="By Type" dropup >
			                        <MenuItem header>By Type </MenuItem>
			                        <MenuItem className="seed_list1" eventKey={''} onClick={()=>this.getBookingsFilterbyType('')} >All</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={0} onClick={()=>this.getBookingsFilterbyType(0)} >Seed</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={1} onClick={()=>this.getBookingsFilterbyType(1)} >Product</MenuItem>
			                    </DropdownButton> 
			                </ButtonToolbar>
			            </li>
			        </ul>
			    </section> : <section className="seed_sort dsl_srt">
			        <ul>
			            <li className="col-md-12 col-xs-12 col-sm-12 coast_list1">
			                <ButtonToolbar>
			                    <DropdownButton className="order_filter_2" noCaret onClick={this.getBrands} title="By Type" dropup >
			                        <MenuItem header>By Type </MenuItem>
			                        <MenuItem className="seed_list1" eventKey={''} onClick={()=>this.getCancelBookingsFilter('')} >ALL</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={0} onClick={()=>this.getCancelBookingsFilter(0)} >Seed</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={1} onClick={()=>this.getCancelBookingsFilter(1)} >Product</MenuItem>
			                    </DropdownButton> 
			                </ButtonToolbar>
			            </li>
			        </ul>
			    </section>}
			    {/* filter for cancel by orders type
			    <section className="seed_sort dsl_srt">
			        <ul>
			            <li className="col-md-12 col-xs-12 col-sm-12 coast_list1">
			                <ButtonToolbar>
			                    <DropdownButton className="order_filter_2" noCaret onClick={this.getBrands} title="By Type" dropup >
			                        <MenuItem header>By Type </MenuItem>
			                        <MenuItem className="seed_list1" eventKey={''} onClick={()=>this.getCancelBookingsFilter('')} >ALL</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={0} onClick={()=>this.getCancelBookingsFilter(-1)} >Seed</MenuItem>
			                        <MenuItem className="seed_list1" eventKey={1} onClick={()=>this.getCancelBookingsFilter(1)} >Product</MenuItem>
			                    </DropdownButton> 
			                </ButtonToolbar>
			            </li>
			        </ul>
			    </section> */}
			    <Modal className="showModal" show={this.state.cancel_success_status} onHide={this.close}  >
					<Modal.Body>
		          		<h4 style={{fontSize:'14px', color:'#666',textAlign:'center'}}>{this.state.cancel_success_msg}</h4>
		        	</Modal.Body>
		        </Modal>
			</div>
		);
	}
}

function mapStateToProps(state){
    return {
 		rzp_keys: state.posts.rzp_keys
    }
}
export default connect(mapStateToProps,actions)(My_Orders);


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Orders/My_Orders.js
 **/